// Horizontal gap (in px) between selected-value chips; matches the container's `gap-1`.
export const GAP = 4;
// Width (in px) reserved for the "+N" overflow counter when chips don't all fit.
export const OVERFLOW_WIDTH = 44;
// Width (in px) reserved for the trailing chevron icon when measuring available space.
export const CHEVRON_WIDTH = 24;
